import { render } from "./AlertModal.vue?vue&type=template&id=813022ce"
const script = {}

import "./AlertModal.vue?vue&type=style&index=0&id=813022ce&lang=css"

import exportComponent from "/home/bammer/vue/doit-vue/vue-todo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__